import React, { useState, useEffect } from 'react';
import { Container, Box, Avatar, Grid, Typography } from '@mui/material';
import { Button } from 'backoffice-react-components';
import getImagePath from '../../utils/helpers/getImagePath';
import { getFBstatus } from './screenSelection';
import { IFeedBackProps, IFeedBackStatus } from '../../interfaces';

const FeedbackScreen = ({ status, onClick, goBack }: IFeedBackProps) => {
  const [fb] = useState<IFeedBackStatus>(getFBstatus(status));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box sx={{ flex: '1 1 auto', marginTop: '1.5rem', width: '100%', height: '200px' }}>
        <Box
          sx={{ flex: '1 1 auto' }}
          style={{
            marginBottom: '5rem',
            padding: '10px',
            borderBottomLeftRadius: '200px',
            borderBottomRightRadius: '200px',
            height: '200px',
            position: 'relative',
          }}
        >
          <Box src={getImagePath(fb.background)} style={{ height: '100%', width: '100%' }} alt={status} component="img" />
          <Avatar
            alt="Remy Sharp"
            src={getImagePath(fb.img)}
            style={{
              position: 'absolute',
              marginLeft: 'auto',
              marginRight: 'auto',
              left: '0',
              right: '0',
              top: '100px',
            }}
            sx={{ width: 150, height: 150 }}
          />
        </Box>
        <Container maxWidth="xs" sx={{ paddingBottom: '1.5rem' }}>
          <Typography align="center" variant="h1" sx={{ mt: 2, mb: 1, fontWeight: 800 }}>
            {fb.title}
          </Typography>
          <Typography dangerouslySetInnerHTML={{ __html: fb.subTitle }} align="center" variant="subtitle1" sx={{ mt: 2, mb: 3 }} />
          {status === 'UNIDENTIFIED' && (
            <>
              <Box src={getImagePath(fb.scan_img!)} style={{ height: '100%', width: '100%' }} alt={status} component="img" />
              <Box
                style={{
                  margin: '1rem 0',
                  padding: '10px',
                  display: 'flex',
                  justifyContent: 'space-evenly',
                }}
              >
                <Box
                  component="img"
                  style={{ height: '100%', width: '100%', marginRight: '1vw', cursor: 'pointer' }}
                  alt="GOOGLE PLAY STORE"
                  src={getImagePath(fb.android_img!)}
                  onClick={onClick}
                />
                <Box
                  component="img"
                  style={{ height: '100%', width: '100%', marginLeft: '1vw', cursor: 'pointer' }}
                  alt="APPLE APP STORE"
                  src={getImagePath(fb.apple_img!)}
                  onClick={onClick}
                />
              </Box>
            </>
          )}
          <Grid style={{ textAlign: 'center' }}>
            <Button label={fb.buttonTitle} onClick={status === 'UNIDENTIFIED' ? goBack! : onClick} />
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default FeedbackScreen;
